module.exports = __webpack_public_path__ + "static/media/checkCircle.7e4624f9.svg";